// src/com/plan_stat/TransPlanStateForDcLine.js
import React, { useState, useEffect, useRef } from 'react';
import { styled  } from '@mui/material/styles';
import { Box } from '@mui/system';
import { AppStyle } from '../../value/AppConst';
import { SorterLabel } from '../../common/SorterLabel';

const LineBox = styled(Box)({
    borderBottom: AppStyle.BorderCCC,
    minHeight: 60,
    display: 'flex', alignItems: 'start', padding: '0.1rem 0 0.3rem 0',
});

const Row = styled(Box)({
    marginTop: '0.2rem',
});

const StoreNameBox = styled(Box)({
    width: '20%', minWidth: 100,
    textAlign: 'center',
});

const TsrBox = styled(Box)({
    textAlign: 'right', marginLeft: '0.5rem',
});
const LabelSpan = styled('span')({fontSize: '0.8rem', color: '#888', marginRight: '0.5rem'});

const HochaLabel = styled('span')({fontSize: '0.8rem', marginLeft: '0.1rem', color: '#555'});
const Hocha = ({hocha}) => <Row>
    {hocha}<HochaLabel>호차</HochaLabel>
</Row>;

const Time = styled('span')({
    // same width letters
    fontFamily: 'Courier New, monospace', fontSize: '1.05rem', fontWeight: 'bold',
})
const TsrMark = styled('span')({
    padding: '0.1rem 0rem', borderRadius: '1rem', border: '1px solid ' + AppStyle.PrimaryRGB,
    color: AppStyle.PrimaryRGB, textAlign: 'center', fontSize: '0.85rem', minWidth: 80,
    display: 'inline-block', boxSizing: 'border-box',
});
const NoTsrMark = styled('span')({
    padding: '0.1rem 0rem', borderRadius: '1rem', border: '1px solid #ccc',
    color: '#ccc', textAlign: 'center', fontSize: '0.85rem', minWidth: 80,
    display: 'inline-block', boxSizing: 'border-box',
});
const TsrRow = ({reqStateFlag}) => <Row>
    {reqStateFlag === '2' ? <TsrMark>TSR 발행</TsrMark> : <NoTsrMark>TSR미발행</NoTsrMark>}
</Row>;

/**
 * 배차현황 테이블의 한 줄
 */
export default function TransPlanStateForDcLine({
    item,
    index,
    indexSelected,
    onClick,
    onClickSorter, // (id, sortState) => void
    idSorted, // id of the column that is currently sorted
}) {
    const [isVisible, setIsVisible] = useState(false);
    const itemRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                // Update state when intersection status changes
                setIsVisible(entry.isIntersecting);
            },
            {
                root: null, // viewport
                rootMargin: '0px',
                threshold: 0.1, // trigger when 10% of the element is visible
            }
        );

        const currentRef = itemRef.current;
        if (currentRef) {
            observer.observe(currentRef);
        }

        // Cleanup observer on component unmount
        return () => {
            if (currentRef) {
                observer.unobserve(currentRef);
            }
        };
    }, []);

    const renderLine = () => {
        return(
            <>
                <StoreNameBox>
                    <Row>{item.storeName}</Row>
                    <Hocha hocha={item.hocha}/>
                    <TsrRow reqStateFlag={item.reqStateFlag}/>
                </StoreNameBox>
                <Box style={{flexGrow:1}}>
                    <Row>{item.vehPlates}</Row>
                    <Row>{item.driverName}</Row>
                    <Row>{item.vehTypeName}</Row>
                </Box>
                <TsrBox>
                    <Row>
                        <LabelSpan>출발요청</LabelSpan>
                        <Time>{item.dptrReqTime ? item.dptrReqTime.substring(11, 16) : '-'}</Time>
                    </Row>
                    <Row>
                        <LabelSpan>도착요청</LabelSpan>
                        <Time>{item.arrReqTime ? item.arrReqTime.substring(11, 16) : '-'}</Time>
                    </Row>
                    <Row>{item.comName}</Row>
                </TsrBox>
            </>
        );
    };

    if(!item) {
        return (
            <Box
                style={{
                    display: 'flex', alignItems: 'center',
                    backgroundColor: AppStyle.PrimaryRGB, color: 'white',
                    textAlign: 'center', padding: '0.5rem 0',
                }}
            >
                <StoreNameBox>
                    <SorterLabel id="storeName" label="도착지"
                        onClick={onClickSorter}
                        idSorted={idSorted}
                    />
                </StoreNameBox>
                <Box style={{flexGrow:1}}>
                    <SorterLabel id="vehPlates" label="차량"
                        onClick={onClickSorter}
                        idSorted={idSorted}
                    />,
                    <SorterLabel id="driverName" label="운전사" marginLeft={10}
                        onClick={onClickSorter}
                        idSorted={idSorted}
                    />,
                    <SorterLabel id="vehTypeName" label="차종" marginLeft={10}
                        onClick={onClickSorter}
                        idSorted={idSorted}
                    />
                </Box>
                <TsrBox style={{marginRight: '1rem'}}>
                    <SorterLabel id="dptrReqTime" label="출발"
                        onClick={onClickSorter}
                        idSorted={idSorted}
                    />,
                    <SorterLabel id="arrReqTime" label="도착" marginLeft={10}
                        onClick={onClickSorter}
                        idSorted={idSorted}
                    />
                </TsrBox>
            </Box>
        )
    }

    return(
        <LineBox
            ref={itemRef}
            onClick={() => {
                onClick(item, index);
            }}
            style={{
                backgroundColor: index===indexSelected ? '#e0f7fa' : index % 2 === 0 ? '#ffffff' : '#f9f9f9',
            }}
        >
            {isVisible ? renderLine() : null}
        </LineBox>
    );
}